// @ts-nocheck
export const notificationHandler = {
  //
  updateReadNotification() {
    const { siteNotifications } = this.state;
    let newReadIds = [];
    siteNotifications.forEach((item) => {
      if (!item.read) {
        newReadIds.push(item.notificationId);
      }
      item.read = true;
    });
    this.postCommands.readNotification(siteNotifications, newReadIds);
    this.setState({
      siteNotifications,
    });
  },

  generateNotificationList() {
    const { userProfileInfo } = this.state;
    const { notificationList } = this.state;

    let notifications = [];
    const notificationsRead = userProfileInfo.notifications_read || [];
    let readNotifs = notificationsRead.map((item) => parseInt(item, 10));
    notificationList.forEach((note, index) => {
      let isRead = readNotifs.includes(note.Id);
      notifications.push({
        id: index,
        notificationId: note.Id,
        message: note.notification_message,
        timestamp: note.postedDate,
        read: isRead,
      });
    });
    notifications.reverse();
    return notifications;
  },

  //
};
